// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__urUCa > div:first-child {
  position: absolute;
  top: 0rem; }

.styles_contentContainer__OxCel {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center; }

.styles_card__k3EvM {
  height: 90%;
  width: 90%;
  padding: 1rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/membership/components/screens/membership-settings/styles.module.scss"],"names":[],"mappings":"AAAA;EAEQ,kBAAkB;EAClB,SAAS,EAAA;;AAIjB;EACI,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGvB;EACI,WAAW;EACX,UAAU;EACV,aAAa,EAAA","sourcesContent":[".container {\n    & > div:first-child {\n        position: absolute;\n        top: 0rem;\n    }\n}\n\n.contentContainer {\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.card {\n    height: 90%;\n    width: 90%;\n    padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__urUCa`,
	"contentContainer": `styles_contentContainer__OxCel`,
	"card": `styles_card__k3EvM`
};
export default ___CSS_LOADER_EXPORT___;
